<template>
    <div>
        <div class="d-flex justify-content-center card-intro text-center mb-4">
            <div class="" style="width: 100%; max-width: 500px;">
                <h1 class="text-32 text-center">Let's review your options.</h1>
                <p class="pt-2">
                    Based on the information you entered, it looks like Wondr isn't offered through your employer or health plan at this time. But good news—join today with our best deal yet.
                </p>
            </div>
        </div>
        <div class="d-flex justify-content-center card-intro text-center">
            <div style="width: 100%; max-width: 350px;">
                <div class="card rounded-sm shadow-lg">
                    <div class="card-body py-4 text-center">
                        <h2 class="text-32 text-weight-normal mb-2">Our best deal</h2>
                        <p class="text-20"><span class="text-48 text-secondary">$50</span>/month</p>
                        <p class="mb-0">
                            <a href="/cart?product=609" class="btn primary-light shadow btn-block">Purchase Now</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>

</style>